
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 6a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z","fill":"#CBD5E0"}})])
          )
        }
      }
    